import { ToolsView } from '../../../_generated';
import { ToolsAction, ToolsActionType } from '../../actionstypes/tools/tools.actiontype';

const initialState: ToolsView[] = [];

export default (state = initialState, action: ToolsActionType): ToolsView[] => {
  switch (action.type) {
    case ToolsAction.Get:
      return action.payload;

    case ToolsAction.Reset:
      return [];

    default:
      return state;
  }
};
